import { Box } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import TimeApproval from "./TimeApproval";
import usePageName from "../../../hocs/usePageName";

const TimeApprovalPage = () => {
  // usePageName({
  //   heading: `Approve Time Summary`,
  //   caption: null,
  // });
  const [searchParams, setSearchParams] = useSearchParams();

  return (
    <Box>
      <TimeApproval token={searchParams.get("token")} />
    </Box>
  );
};

export default TimeApprovalPage;
